import { Chip } from '@mui/material'
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material'

export const GoalBadge = ({ variation }) => {
  return (
    <Chip
      size='small'
      color={variation < 0 ? 'error' : 'success'}
      label={`${Math.abs(variation).toFixed(1)}%`}
      icon={variation < 0 ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
      sx={{
        height: 18,
        fontSize: '0.7rem',
        fontWeight: 600,
        padding: '4px',
        borderRadius: '9999px',
        backgroundColor:
          variation > 0 ? '#59ac2a' : variation > -10 ? '#f0b222' : '#f34455',
        '& .MuiChip-label': {
          padding: 0,
          paddingRight: '2px'
        },
        '& .MuiChip-icon': {
          marginLeft: 0,
          marginRight: 0,
          fontSize: 14
        }
      }}
    />
  )
}
